export default {
    apiKey: "AIzaSyBE19dPZlepZny1feDTHL4j6F4-oLmf2AQ",
    authDomain: "qorani-librairie.firebaseapp.com",
    projectId: "qorani-librairie",
    storageBucket: "qorani-librairie.appspot.com",
    messagingSenderId: "288871106671",
    appId: "1:288871106671:web:2e079f8fced2608264659a",
    measurementId: "G-LD9GNVHYZC"
  };

